import type { QueryClient } from "@tanstack/react-query";
import { fetchAttendanceLogsForStudents } from "@/lib/services/attendanceService";
import { QueryKeys } from "@/lib/types";
import {
  MEMBER_SCHEDULE_ATTENDANCE_LOOKBACK_DAYS,
  memberScheduleAttendanceDateRange,
} from "@/lib/utils/attendance/memberScheduleAttendance";
import type { GetAttendanceLogResponse } from "@/openapi/generated/models";

function normalizeStudentIds(studentIds: number[]): number[] {
  return [...new Set(studentIds.filter((id) => Number.isFinite(id)))].sort(
    (a, b) => a - b,
  );
}

export async function prefetchMemberScheduleAttendanceLogs(
  studentIds: number[],
  queryClient: QueryClient,
  accessToken: string,
) {
  const ids = normalizeStudentIds(studentIds);
  if (ids.length === 0) return queryClient;

  const sortedKey = ids.join(",");

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.Attendance,
      "member-schedule",
      sortedKey,
      MEMBER_SCHEDULE_ATTENDANCE_LOOKBACK_DAYS,
    ] as const,
    queryFn: async (): Promise<GetAttendanceLogResponse[]> => {
      const { fromDate, toDate } = memberScheduleAttendanceDateRange();
      return fetchAttendanceLogsForStudents(accessToken, ids, fromDate, toDate);
    },
    staleTime: 60_000,
  });

  return queryClient;
}
